import React from 'react';

const BlogAnswer2 = () => {
    return (
        <div>
            <h5 className=' text-success'>Answer:</h5>
            <p>Firebase is able to manage databases in real-time or instantly. Easy to exchange or easily with data migration using firebase, easy process to Authentication or Authorization. it's developer-friendly by google. and Firebase Storage is basically a powerful and simple object storage, in which you can store your files easily.</p>
            <p> <b className=' text-secondary'>Here Some Name of Providers for  implement authentication: </b>  <br />
                STYTCH ,
                Ory ,
                Supabase,
                Okta,
                PingIdentity,
                Keycloak,
                Frontegg,
                Authress,
                Auth0,
                Amazon Cognito,
                OneLogin,
            </p>
        </div>
    );
};

export default BlogAnswer2;